export default () => ({

    // Годы в истории театра
    years: [],

    // Десятилетия в истории театра (для вкладок)
    decades: [],

    // Активное десятилетие (активная вкладка)
    activeDecade: false,

    // Предыдущее активное десятилетие (для навигации)
    prevActiveDecade: false,

    // Следующее активное десятилетие (для навигации)
    nextActiveDecade: false,

    /**
     * Инициализация компонента
     */
    init() {

        // noinspection JSUnresolvedReference
        this.years = JSON.parse(this.$root.dataset.years);

        // noinspection JSUnresolvedReference
        this.decades = JSON.parse(this.$root.dataset.decades);

        // noinspection JSUnresolvedReference
        this.activeDecade = parseInt(this.$root.dataset.activeDecade ?? this.decades[0] ?? 0);

        // noinspection JSUnresolvedReference
        this.$watch('activeDecade', () => {
            this.prevActiveDecade = this.getPrevActiveDecade();
            this.nextActiveDecade = this.getNextActiveDecade();
        });

        this.prevActiveDecade = this.getPrevActiveDecade();
        this.nextActiveDecade = this.getNextActiveDecade();
    },

    /**
     * Установить выбранное десятилетие
     */
    setActiveDecade(decade) {

        let hasEvents = this.isDecadeHasEvents(decade);

        if (!hasEvents) {
            return;
        }

        this.activeDecade = decade;
    },

    /**
     * Является ли десятилетие выбранным
     */
    isActiveDecade(decade) {

        return this.activeDecade === decade;
    },

    /**
     * Массив годов десятилетия
     */
    getDecadeYears(decade) {

        let years = [];

        for (let i = 0; i < 10; i++) {
            years.push(decade + i);
        }

        return years;
    },

    /**
     * Есть ли записи в году
     */
    isYearHasEvents(year) {

        return this.years.some((yr) =>
            parseInt(yr) === parseInt(year));
    },

    /**
     * Есть ли записи в десятилетии
     */
    isDecadeHasEvents(decade) {

        let years = this.getDecadeYears(decade);

        return years.some((year) =>
            this.years.some((yr) =>
                parseInt(yr) === parseInt(year)));
    },

    /**
     * Найти предыдущее активное десятилетие
     */
    getPrevActiveDecade() {

        if (this.decades.length < 2) {
            return false;
        }

        let i = 0;

        // Находим индекс выбранного десятилетия
        for (i; i < this.decades.length; i++) {
            if (this.isActiveDecade(this.decades[i])) {
                break;
            }
        }

        // Получаем индекс предыдущего десятилетия
        i = i - 1;

        // Ищем предшествующее десятилетие с записями
        for (i; i >= 0; i--) {

            let decade = this.decades[i];

            if (this.isDecadeHasEvents(decade)) {
                return decade;
            }
        }

        // Нет предшествующих десятилетий с записями
        return false;
    },

    /**
     * Найти предыдущее активное десятилетие
     */
    getNextActiveDecade() {

        if (this.decades.length < 2) {
            return false;
        }

        let i = 0;

        // Находим индекс выбранного десятилетия
        for (i; i < this.decades.length; i++) {
            if (this.isActiveDecade(this.decades[i])) {
                break;
            }
        }

        // Получаем индекс следующего десятилетия
        i = i + 1;

        // Ищем следующее десятилетие с записями
        for (i; i <= this.decades.length; i++) {

            let decade = this.decades[i];

            if (this.isDecadeHasEvents(decade)) {
                return decade;
            }
        }

        // Нет следующих десятилетий с записями
        return false;
    }

})
